<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <package-title />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <package-content />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <project-package-project />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import PackageTitle from '@/views/Admin/Project_packages/Elements/Title.vue'
import PackageContent from '@/views/Admin/Project_packages/Elements/Content.vue'
import ProjectPackageProject from '@/views/Admin/Project_packages/Elements/Project.vue'

export default {
  name: 'ProjectPackagesItemForm',
  components: {
    ProjectPackageProject,
    PackageContent,
    PackageTitle,
    BCard,
    BRow,
    BCol,
  },
}
</script>
